let timelineElements = [
    {
      id: 1,
      title: "Meet the Brothers/Info Session",
      location: "ECSW 1.315 (Clark Auditorium)",
      description:
       "Join us for an informative session to meet the brothers of Theta Tau Alpha, an engineering fraternity committed to academic excellence and professional growth. Discover our values, activities, and how Theta Tau Alpha can enhance your engineering experience.",
      buttonText: "View Frontend Projects",
      date: "February 2nd 2024",
      icon: "work",
    },
    {
      id: 2,
      title: "Backend Developer",
      location: "Skystead, Craonia",
      description:
        "Working hand-in-hand with front-end developers by providing the outward facing web application elements server-side logic. Creating the logic to make the web app function properly, and accomplishing this through the use of server-side scripting languages.",
      buttonText: "View Backend Projects",
      date: "June 2013 - August 2016",
      icon: "work",
    },
    {
      id: 3,
      title: "Quality Assurance Engineer",
      location: "South Warren, Geshington",
      description:
        "Assessing the quality of specifications and technical design documents in order to ensure timely, relevant and meaningful feedback.",
      buttonText: "Company Website",
      date: "September 2011 - June 2013",
      icon: "work",
    },
    {
      id: 4,
      title: "Oak Ridge College",
      location: "South Warren, Geshington",
      description:
        "Online Course in Magical Beasts and Wonders of the World - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque sagittis tellus, non ultrices lacus tempus vel.",
      buttonText: "Course Certificate",
      date: "September 2011",
      icon: "work",
    },
    {
      id: 5,
      title: "Hawking College",
      location: "Skystead, Craonia",
      description:
        "College - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque sagittis tellus, non ultrices lacus tempus vel.",
      buttonText: "College Projects",
      date: "2007 - 2011",
      icon: "work",
    },
    {
      id: 6,
      title: "Marble Hills Grammar School",
      location: "Dragontail, Ascana",
      description:
        "Highschool - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque sagittis tellus, non ultrices lacus tempus vel.",
      date: "2003 - 2007",
      icon: "work",
    },
  ];
  
  export default timelineElements;